module.exports = __webpack_public_path__ + "img/stackslash-20.bf7c87b0.jpg";